import React, { useState } from "react";
import { ICouncilMemberData } from "../../exports/interfaces";
import { formatUrl } from "../../exports/functions";
import PopUpDialog from "../PopUpDialog";
import DynamicToolTip from "../DynamicToolTip";
import { Fade } from "react-awesome-reveal";

const CouncilMember = (props: { councilMemberData: ICouncilMemberData[] }) => {
  const [open, setOpen] = useState(false);
  const [selectedMember, setSelectedMember] =
    useState<ICouncilMemberData | null>(null);

  const handleClickOpen = (member: ICouncilMemberData) => {
    setSelectedMember(member);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedMember(null);
  };

  const groupedData = props.councilMemberData.reduce((acc, item) => {
    const category = item.attributes.Category;

    const existingCategory = acc.find((group) => group.category === category);

    if (existingCategory) {
      existingCategory.data.push(item);
    } else {
      acc.push({ category, data: [item] });
    }

    return acc;
  }, [] as { category: string; data: typeof props.councilMemberData }[]);

  return (
    <>
      {groupedData?.map((group, index) => (
        <section className="volunteers-one" key={index}>
          <div className="container">
            <div className="section-title text-center">
              <h2 className="section-title__title">{group.category}</h2>
            </div>
            <div className="row">
              {group.data.map((member, index) => (
                <div className="col-xl-3 col-lg-3 col-md-6" key={member.id}>
                  <Fade key={index} cascade damping={0.2} triggerOnce={true} delay={index * 200}>
                  <div className="volunteers-one__single">
                    <div className="volunteers-one__img">
                      <img
                        src={`${process.env.REACT_APP_strapiUrl}${member.attributes.Image.data.attributes.url}`}
                        alt="council-image"
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "225px",
                          // height: "200px",
                        }}
                      />
                      <div className="volunteers-one__social">
                        <DynamicToolTip title="TwitterX">
                          <a
                            href={formatUrl(member.attributes.TwitterX_Link)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <i className="fab fa-twitter"></i>
                          </a>
                        </DynamicToolTip>
                        <DynamicToolTip title="Facebook">
                          <a
                            href={formatUrl(member.attributes.Facebook_Link)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <i className="fab fa-facebook"></i>
                          </a>
                        </DynamicToolTip>
                        <DynamicToolTip title="Instagram">
                          <a
                            href={formatUrl(member.attributes.Instagram_Link)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <i className="fab fa-instagram"></i>
                          </a>
                        </DynamicToolTip>
                      </div>
                    </div>
                    <div className="volunteers-one__content">
                      <h4
                        className="volunteers-one__name custom-grid-font-size"
                        onClick={() => handleClickOpen(member)}
                        style={{ cursor: "pointer" }}
                      >
                        {member.attributes.Name}
                      </h4>
                      <p
                        className="volunteers-one__title"
                        style={{ textTransform: "capitalize" }}
                      >
                        {member.attributes.Category.toLowerCase().replace(
                          /\b\w/g,
                          (char) => char.toUpperCase()
                        )}
                      </p>
                    </div>
                  </div>
                  </Fade>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}
      <PopUpDialog open={open} onClose={handleClose} member={selectedMember} />
    </>
  );
};

export default CouncilMember;
